import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import DiscountForm from './forms/DiscountForm';
import DiscountList from './lists/DiscountList';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import {isTrue} from "../../utils/other";

class DiscountEditor extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            editorHeader: this.props.values.name || "Új kedvezmény felvitele"
        }
    }

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.setState({editorHeader: data.name});
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.setState({editorHeader: "Új kedvezmény felvitele"});
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        return (
            <Fragment>
                <List
                    {...this.props}
                    header={"Kedvezmények"}
                    theme="default"
                    footer={[
                        <Button key="0" type="button" color="default" disabled={this.props.isLoading} onClick={ this.pristineForm }>
                            Új
                        </Button>
                    ]}
                >
                    <DiscountList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
                </List>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header={this.state.editorHeader}
                    footer={[
                        <Button key="0" type="button" disabled={ !this.props.dirty || this.props.isLoading } color="primary" className="pull-right" onClick={ this.saveForm }>
                            Mentés
                        </Button>,
                        <Button key="1" disabled={!this.props.values[this.props.componentConfig.idfield]}
                                color="danger"
                                className="pull-left"
                                onClick={this.props.deleteForm}>
                            Törlés
                        </Button>
                    ]}
                >
                    <DiscountForm {...this.props} />
                </Editor>
            </Fragment>
        );
    }
}

export default createEditor({componentName: "Discount", WrappedComponent: DiscountEditor, props: {
    view: "admin",
    componentActions: (action, data) => {
        data.promotion = data.promotion && data.promotion.id;
        data.sametarget = isTrue(data.sametarget);
        if (data.sametarget) {
            data.conditions = [];
        }
        if (data.type === "packagediscount") {
            data.exclusions = [];
            (data.targets || []).map((target) => {
                if (target.property !== "id") {
                    throw {message: "Csomag kedvezményben csak id/kód által kiválsztott termékek lehetnek a cél szűrésben!"};
                }
            });
        }

        return {action,data};
    }
}});
